import { graphql } from "../../../services/wp.api.service";

const query = `
mutation MyMutation2($newPassword: String!, $password: String!, $confirmNewPassword: String!) {
	changeUserPassword(
	  input: {confirmNewPassword: $confirmNewPassword, newPassword: $newPassword, password: $password}
	) {
	  success
	}
}
`;

/**
 *
 * @param {func} useMutation The ReactQuery useMutation hook.
 * @param {*}    options     Custom mutation options.
 *
 * @returns Promise
 */
export const changeMyPasswordMutation = (useMutation, options) => useMutation(
	["change_password"],
	(variables) => graphql({
		query,
		variables
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return data?.data?.changeUserPassword;
		}),
	{ ...options }
);
